// extracted by css-extract-rspack-plugin
export default {"wrapper":"product-detail-fragment__ImageGalleryWithFallback_wrapper__K9grZ"};